// Need to use the React-specific entry point to allow generating React hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { UserCompare } from '../../pages/api/userCompare';

// Define a service using a base URL and expected endpoints
export const userCompare = createApi({
  reducerPath: 'userCompare',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/',
    async prepareHeaders(headers, { getState }) {
      // @ts-ignore
      headers.set('token', getState().auth.user.accessToken);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getUserCompare: builder.query<
      UserCompare,
      { matchName: string; year: string; surname: string }
    >({
      query: ({ matchName, year, surname }) => ({
        url: 'userCompare',
        params: { matchName, year, surname },
      }),
    }),
  }),
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useLazyGetUserCompareQuery } = userCompare;
